export {App as default} from './App';
